import { useState, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router";
import AffiliateDashboard from "./NewDashboard/NewDashboard";
import Tabs from "../../reusableComponents/Tabs/Tabs";
import AffiliateTable from "./Dashhboard/AffiliateTable";
import CommissionPayment from "./CommissionPayment";
import CreateAffiliate from "./CreateAffililiate";
import { ReactComponent as OverviewIcon } from "../../assets/icons/overview.svg";
import { ReactComponent as AffiliateCodeIcon } from "../../assets/icons/affiliateCodeIcon.svg";
import { ReactComponent as AffiliatePayoutIcon } from "../../assets/icons/AffiliatePayoutIcon.svg";

const AffiliatePage = () => {
  const [active, setActive] = useState(1);
  const location = useLocation();

  const items = [
    { label: "Overview", path: "overview", value: 1, icon: <OverviewIcon /> },
    {
      label: "Affiliate Codes",
      path: "affiliate-codes",
      value: 2,
      icon: <AffiliateCodeIcon />,
    },
    {
      label: "Commission Payouts",
      path: "affiliate-payout",
      value: 3,
      icon: <AffiliatePayoutIcon />,
    },
  ];

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop(); // Get the last part of the pathname
    const activeItem = items.find((item) => item.path === currentPath);
    if (activeItem) {
      setActive(activeItem.value);
    } else {
      setActive(1); // Default to Overview if no match
    }
  }, [location.pathname]);

  return (
    <div className="PageContainer">
      <Tabs items={items} active={active} setActive={setActive} />
      <Routes>
        <Route path="/" element={<Navigate to="overview" replace={true} />} />
        <Route path="/overview" element={<AffiliateDashboard />} />
        <Route path="/create-affiliate" element={<CreateAffiliate />} />
        <Route path="/affiliate-codes" element={<AffiliateTable />} />
        <Route path="/affiliate-payout" element={<CommissionPayment />} />
      </Routes>
    </div>
  );
};

export default AffiliatePage;
